import { action, computed, makeObservable, observable } from 'mobx';
import Settings from '../models/settings';
import processIncomingData from '../processIncomingData';
import { getCustomerFromSmsChannel } from '../../helpers/contactHelpers';

class SettingsStore {
  constructor(rootStore) {
    makeObservable(this);
    this.rootStore = rootStore;
  }

  @observable settings = [];

  @computed get getLoggedUserSettings() {
    return this.settings.find(
      (f) => f.User && f.User._id === this.rootStore.commonStore.loggedUserId
    );
  }

  @computed get getUserPersistentNotifications() {
    return this.getLoggedUserSettings && this.getLoggedUserSettings?.PersistentNotificationMessages;
  }

  @computed get getUserHasSnoozedNotifications() {
    return (
      this.getLoggedUserSettings &&
      this.getLoggedUserSettings.SnoozeNotificationsUntil &&
      new Date(this.getLoggedUserSettings.SnoozeNotificationsUntil) > new Date()
    );
  }

  @computed get getCustomerInSelectedChannel() {
    return getCustomerFromSmsChannel(this?.getLoggedUserSettings?.SelectedChannel);
  }

  @computed get getOtherContactInDmSelectedChannel() {
    return this?.getLoggedUserSettings?.SelectedChannel?.Contacts.find(
      (c) => c._id !== this?.rootStore?.commonStore?.getLoggedUser?._id && !c.IsDeleted
    );
  }

  @computed get getIsLoggedUserInSelectedChannel() {
    return this?.getLoggedUserSettings?.SelectedChannel?.Contacts.find(
      (c) => c._id === this?.rootStore?.commonStore?.getLoggedUser?._id
    );
  }

  @action setToggleMuteSounds() {
    this.getLoggedUserSettings.MuteSounds = !this.getLoggedUserSettings.MuteSounds;
  }

  @action setTogglePersistentNotifications() {
    this.getLoggedUserSettings.PersistentNotifications = !this.getLoggedUserSettings
      .PersistentNotifications;
  }

  @action setToggleShowHiddenMessages() {
    this.getLoggedUserSettings.ShowHiddenMessages = !this.getLoggedUserSettings.ShowHiddenMessages;
  }

  @action setSelectedChannel = (channelData) => {
    this.getLoggedUserSettings.SelectedChannel = channelData;
  };

  @action setSnoozeNotificationsUntil = (snoozeNotificationsUntil) => {
    this.getLoggedUserSettings.SnoozeNotificationsUntil = snoozeNotificationsUntil;
  };

  @action setAddSnackbarNotificationMessages = (message) => {
    this.getLoggedUserSettings.PersistentNotificationMessages?.push(message);
  };

  @action setRemoveSnackbarNotificationMessage = (message) => {
    this.getLoggedUserSettings.PersistentNotificationMessages = this.getLoggedUserSettings.PersistentNotificationMessages.filter(
      (f) => f._id !== message._id
    );
  };

  @action setClearSnackbarNotificationMessages = () => {
    this.getLoggedUserSettings.PersistentNotificationMessages = [];
  };

  @action setChannelFilterPeriod = (months) => {
    this.getLoggedUserSettings.FilterRecentMessagesFrom = months;
  };

  @computed get getChannelFilterDropdownIndex() {
    return this.getLoggedUserSettings.FilterRecentMessagesFrom
      ? this.getLoggedUserSettings.FilterRecentMessagesFrom - 1
      : null;
  }

  @action UpsertAndGet(incObj) {
    return processIncomingData(incObj, this.rootStore, this.settings, Settings);
  }
}

export default SettingsStore;
